import * as React from 'react';
import PropTypes from "prop-types";
import {Col, FormFeedback, FormGroup, Input, Label} from "reactstrap";
import LabelInfoTooltip from "../../LabelInfoTooltip";
import SupplierDocumentsTypeSelect from "./SupplierDocumentsTypeSelect";
import ApplicationSwitch from "../../Application/ApplicationSwitch";

function SupplierJaroFiltrFields(props) {
  return (
    <React.Fragment>
      <FormGroup row>
        <Label md={3}>Login</Label>
        <Col md="9">
          <Input invalid={!!props.errors.login?.errors} placeholder="Login" onChange={e => props.onChangeData({login: e.target.value})} value={props.data.login || ''} />
          <FormFeedback>{props.errors.login?.errors?.join('; ')}</FormFeedback>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Klucz</Label>
        <Col md="9">
          <Input invalid={!!props.errors.password?.errors} placeholder="Klucz" onChange={e => props.onChangeData({password: e.target.value})} value={props.data.password || ''} />
          <FormFeedback>{props.errors.password?.errors?.join('; ')}</FormFeedback>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Rodzaj dokumentów <LabelInfoTooltip msg={"Rodzaj dokumentów z których będą pobierane zamówione towary."} /></Label>
        <Col md="9">
          <SupplierDocumentsTypeSelect
            value={props.data.documentsType}
            onChange={documentsType => props.onChangeData({documentsType})}
          />
          <FormFeedback>{props.errors.documentsType?.errors?.join('; ')}</FormFeedback>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Pobieraj korekty faktur</Label>
        <Col md="9">
          <ApplicationSwitch color={'success'} onChange={e => props.onChangeData({ downloadCorrection: e.target.checked ? 1 : 0 })} checked={props.data.downloadCorrection} />
        </Col>
      </FormGroup>
    </React.Fragment>
  );
}

SupplierJaroFiltrFields.propTypes = {
  onChangeData: PropTypes.func.isRequired,
  data: PropTypes.shape({
    login: PropTypes.string,
    password: PropTypes.string,
  }).isRequired,
  errors: PropTypes.object.isRequired,
};

export default SupplierJaroFiltrFields;
